import { Component, OnInit } from '@angular/core';
import { SignInDto } from '@models/users/sign-in.dto';
import { SubscriberDto } from '@models/users/subscriber.dto';
import { AccountService } from '@services/account.service';
import { SubscriberService } from '@services/subscriber.service';

@Component({
  selector: 'ebs-user-access',
  templateUrl: './user-access.component.html',
  styleUrls: ['./user-access.component.scss'],
})
export class UserAccessComponent implements OnInit {
  public subscribers: SubscriberDto[] = [];
  public auths: SignInDto[] = [];

  public search: string = '';

  constructor(
    private subscriberService: SubscriberService,
    private authService: AccountService,
  ) {}

  ngOnInit() {}
}
